/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OrganizationSection_organization$ref: FragmentReference;
declare export opaque type OrganizationSection_organization$fragmentType: OrganizationSection_organization$ref;
export type OrganizationSection_organization = {|
  +anchorRole: {|
    +chartPath: any
  |},
  +$refType: OrganizationSection_organization$ref,
|};
export type OrganizationSection_organization$data = OrganizationSection_organization;
export type OrganizationSection_organization$key = {
  +$data?: OrganizationSection_organization$data,
  +$fragmentRefs: OrganizationSection_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrganizationSection_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "anchorRole",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "chartPath",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'dfd8c793dc2dd87f1c42e6c7d0d292d0';

module.exports = node;
